// Homepage only: the "Latest Reviews" slider. The gallery itself is driven by filter.js.
document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('[data-home-reviews]');
    if (!section) return;

    const viewport = section.querySelector('[data-home-reviews-track]');
    const slides = Array.from(section.querySelectorAll('[data-home-review-slide]'));
    const controls = section.querySelector('[data-home-reviews-controls]');
    const previous = section.querySelector('[data-home-review-prev]');
    const next = section.querySelector('[data-home-review-next]');
    const indicators = Array.from(section.querySelectorAll('[data-home-review-go]'));
    if (!viewport || slides.length < 2 || !controls || !previous || !next) return;

    controls.hidden = false;
    let activeIndex = 0;
    let scrollFrame = 0;
    let settleTimer = 0;

    const setActive = (index) => {
        activeIndex = Math.max(0, Math.min(slides.length - 1, index));
        indicators.forEach((indicator, indicatorIndex) => {
            const active = indicatorIndex === activeIndex;
            indicator.classList.toggle('is-active', active);
            indicator.setAttribute('aria-current', active ? 'true' : 'false');
        });
    };

    const goTo = (index) => {
        const targetIndex = (index + slides.length) % slides.length;
        const slide = slides[targetIndex];
        const left = slide.getBoundingClientRect().left - viewport.getBoundingClientRect().left + viewport.scrollLeft;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        setActive(targetIndex);
        viewport.scrollTo({ left, behavior: reducedMotion ? 'auto' : 'smooth' });
    };

    const updateActiveFromScroll = () => {
        cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(() => {
            const viewportLeft = viewport.getBoundingClientRect().left;
            let closestIndex = 0;
            let closestDistance = Infinity;
            slides.forEach((slide, index) => {
                const distance = Math.abs(slide.getBoundingClientRect().left - viewportLeft);
                if (distance < closestDistance) {
                    closestDistance = distance;
                    closestIndex = index;
                }
            });
            setActive(closestIndex);
        });
    };

    previous.addEventListener('click', () => goTo(activeIndex - 1));
    next.addEventListener('click', () => goTo(activeIndex + 1));
    indicators.forEach((indicator) => {
        indicator.addEventListener('click', () => goTo(Number(indicator.dataset.homeReviewGo)));
    });

    viewport.addEventListener('scroll', () => {
        updateActiveFromScroll();
        window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(updateActiveFromScroll, 120);
    }, { passive: true });
    viewport.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
            event.preventDefault();
            goTo(activeIndex - 1);
        } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            goTo(activeIndex + 1);
        }
    });

    if ('ResizeObserver' in window) {
        new ResizeObserver(updateActiveFromScroll).observe(viewport);
    } else {
        window.addEventListener('resize', updateActiveFromScroll, { passive: true });
    }
});

